import { Carousel } from '@liveauctioneers/hammer-ui-core/carousel';
import { fetchHomeDataIfNeeded } from '@/redux/modules/home/home.actions';
import { getItemSummaries } from '@/redux/modules/item/summary/itemSummary.selectors';
import { getTrendingItems } from '@/redux/modules/home/home.selectors';
import { SingleCard } from '@liveauctioneers/hammer-ui-core/card/singleCard';
import { TrendingItemCard } from './components/TrendingItemCard';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useEffect, useMemo } from 'react';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';

const MAX_SKELETON_CARDS = 6;

export const SeeWhatsPopularSection = () => {
    const dispatch = useAppDispatch();
    const { formatMessage } = useIntl();
    const trendingItemIds = useAppSelector(getTrendingItems);
    const trendingItemSummaries = useAppSelector((state) => getItemSummaries(state, trendingItemIds));

    const youMayAlsoLikeCards = useMemo(() => {
        // Load skeleton cards if trendingItemSummaries is empty
        if (trendingItemSummaries.length === 0) {
            return new Array(MAX_SKELETON_CARDS).fill(null).map((_, index) => ({
                card: (
                    <SingleCard
                        card={TrendingItemCard}
                        className="h-[172px] w-[172px]"
                        data={null}
                        forceSkeleton
                        key={`trending-item-card-${index}`}
                    />
                ),
                key: `trending-item-card-${index}`,
            }));
        }
        return trendingItemSummaries.map((card) => ({
            card: (
                <SingleCard
                    card={TrendingItemCard}
                    className="h-[332px] w-[172px]"
                    data={card}
                    forceSkeleton={trendingItemSummaries.length === 0}
                    key={`trending-item-card-${card.itemId}`}
                />
            ),
            key: `trending-item-card-${card.itemId}`,
        }));
    }, [trendingItemSummaries]);

    useEffect(() => {
        dispatch(fetchHomeDataIfNeeded(false));
    }, [dispatch]);

    return (
        <div className="pt-2xl">
            <Carousel
                cards={youMayAlsoLikeCards}
                title={formatMessage({ id: 'see_whats_popular' })}
            />
        </div>
    );
};
